/* istanbul ignore file */

export const maskDefinitions = {
	"@": /[0-9+]/,
	"#": /[0-9+\- ]/
};

export const defaultMask = "@0#####################";
export const intlMask = "{+}*******[*****************]";
export const DefaultDomainPhoneMask = "000-000-0000";

export class PhoneMask {
	static Init(inputElem, domainMask) {
		return new PhoneMask(inputElem, domainMask);
	}

	constructor(inputElem, domainMask) {
		this._domainMask = DefaultDomainPhoneMask; /* domainMask || DefaultDomainPhoneMask;
		this._domainMask = this._domainMask.replace("x", "0"); */

		this._inputElem = inputElem;
		this._mask = null;

		this._RenderMask(defaultMask);

		this._inputElem.addEventListener("keyup", (e) => {
			if (this._mask != null) {
				setTimeout(() => {
					var newMask = this._EvaluateAppropriateMask(this._mask.mask, this._inputElem.value);
					this._RenderMask(newMask);
				}, 200);
			}
		});
	}

	_RenderMask(maskPattern) {
		if (this._mask != null) {
			this._mask.destroy();
		}

		this._mask = window.IMask(this._inputElem, { mask: maskPattern, definitions: maskDefinitions });
		this._mask.on("accept", () => this._ProcessChange());
		this._mask.on("complete", () => this._SetModelOnComplete());
	}

	_ProcessChange() {
		this._SetModelValue("");

		var newMask = this._EvaluateAppropriateMask(this._mask.mask, this._mask.value);
		if (newMask !== this._mask.mask) {
			this._RenderMask(newMask);
		}
	}

	_SetModelOnComplete() {
		this._SetModelValue(this._mask.value);
	}

	_SetModelValue(value) {}

	_EvaluateAppropriateMask(mask, phoneNumber) {
		let modelValue = phoneNumber;
		let currentMask = mask;

		if (!phoneNumber || phoneNumber.length <= 3) {
			currentMask = defaultMask;
		}
		else if (!!phoneNumber && phoneNumber.length > 3 && phoneNumber.indexOf("1-") === 0) {
			currentMask = "{1}-" + this._domainMask;
			modelValue = phoneNumber.replace("1-", "");
		}
		else if (!!phoneNumber && phoneNumber.length > 3 && phoneNumber.indexOf("1 ") === 0) {
			currentMask = "{1} " + this._domainMask;
			modelValue = phoneNumber.replace("1 ", "");
		}
		else if (!!phoneNumber && phoneNumber.length > 3 && phoneNumber.indexOf("+1-") === 0) {
			currentMask = "+{1}-" + this._domainMask;
			modelValue = phoneNumber.replace("+1-", "");
		}
		else if (!!phoneNumber && phoneNumber.length > 3 && phoneNumber.indexOf("+1 ") === 0) {
			currentMask = "+{1} " + this._domainMask;
			modelValue = phoneNumber.replace("+1 ", "");
		}
		else if (!!phoneNumber && phoneNumber.length > 3 && phoneNumber[0] !== "+") {
			currentMask = this._domainMask;
		}
		else {
			currentMask = intlMask;
		}

		return currentMask;
	}
}
